import { Button } from "@material-ui/core"
import { useState } from "react"
import BackDrop from "../../../global/BackDrop"
import { useSelector, useDispatch } from "react-redux"
import { verificarCuentaAction, selectClienteTarget } from "../../../ducks/clientesDuck"
import { ToastMessage } from "../../../global/ToastMessage"
import { DialogMessage } from "../../../global/DialogMessage"
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
const BVerificar = () => {
    const { cliente, referencia, verificado } = useSelector(store => store.cliente)
    const [load, setLoad] = useState(false)
    const dispatch = useDispatch()
    const handleVerificar = () => {
        DialogMessage.fire({
            title: `Verficar cuenta`,
            text: `¿Esta seguro de que la información del cliente es la correcta?`,
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoad(true)
                dispatch(verificarCuentaAction({ IdCuenta: cliente?.Movimiento?.Cuenta?.Id_Cuenta })).then(Response => {
                    if (Response?.status && Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema intentar mas tarde",
                        });
                        return null;
                    }
                    dispatch(selectClienteTarget({ cliente, referencia }))
                    setLoad(false)
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    });
                })
            }
        })
    }

    if (!verificado) return (
        <div>
            <Button onClick={handleVerificar} variant="contained" color="primary">Verificar cuenta</Button>
            <BackDrop open={load} />
        </div>
    )
    return (
        <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: "1%" }}>
            <CheckCircleOutlineIcon color="primary" />
            <p>Cuenta verificada</p>
        </div>
    )
}
export default BVerificar